import React, {useCallback, useMemo} from 'react';
import {NavLink, useNavigate} from 'react-router-dom';
import {PAGES_URL} from '../../helpers/constants';
import {DashboardLayout, SecondaryButton} from '../../components';
import {infoRedSm} from '../../assets/images/images';
import {connect} from 'react-redux';

const ROUTES = [
  {
    name: 'User Screening',
    path: PAGES_URL.AML_USER_SCREENING,
    key: 'user',
  },
  {
    name: 'Business Screening',
    path: PAGES_URL.AML_BUSINESS_SCREENING,
    key: 'business',
  },
];

function Layout({children, auth: {userDetails}}) {
  const navigate = useNavigate();

  const {
    performSingleBusinessLookup,
    viewSingleBusinessLookup,
    performBatchBusinessLookup,
    viewBatchBusinessLookup,
    performSingleIndividualLookup,
    viewSingleIndividualLookup,
    performBatchIndividualLookup,
    viewBatchIndividualLookup,
  } =
    useMemo(
      () => userDetails?.permissions?.amlScreeningPermissions,
      [userDetails],
    ) || {};

  const canPerformBusinessLookup =
    performSingleBusinessLookup &&
    viewSingleBusinessLookup &&
    performBatchBusinessLookup &&
    viewBatchBusinessLookup;

  const canPerformIndividualLookup =
    performSingleIndividualLookup &&
    viewSingleIndividualLookup &&
    performBatchIndividualLookup &&
    viewBatchIndividualLookup;

  const getPermission = useCallback(
    key =>
      ({
        user: canPerformIndividualLookup,
        business: canPerformBusinessLookup,
      }[key]),
    [canPerformBusinessLookup, canPerformIndividualLookup],
  );

  const handleSwitchToNewVersion = () => {
    navigate(PAGES_URL.AML_SCREENING);
  };

  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">AML Screening</p>
      }
    >
      <div className="flex flex-wrap gap-3 items-center pt-4 justify-between">
        <div className="flex flex-wrap items-center gap-2">
          <div className="py-3">
            <div className="rounded-md bg-[#F7F7F7] w-fit p-1 flex items-center gap-2 overflow-x-auto">
              {ROUTES.map((route, index) => (
                <NavLink
                  key={index}
                  end
                  to={route.path}
                  className={({isActive}) =>
                    `px-7 py-1.5 min-h-8 text-sm flex items-center justify-center rounded-lg shadow-[0px_4px_32px_-4px,rgba(199,196,196,0.18)] ${
                      isActive
                        ? 'text-black bg-white shadow-tabs'
                        : 'text-grey-500 bg-transparent'
                    }`
                  }
                  style={{
                    pointerEvents: getPermission(route?.key) ? 'auto' : 'none',
                  }}
                >
                  {route.name}
                </NavLink>
              ))}
            </div>
          </div>
          <div className="bg-[#F8EBEA] p-2 rounded max-w-[357px] font-normal flex items-center gap-2">
            <img src={infoRedSm} alt={'image'} />
            <p className="text-xs text-[#B42318]">
              We will be moving AML to the new version permanently on the 31st
              of August 2025, kindly export all your history before that day
            </p>
          </div>
        </div>

        <SecondaryButton
          buttonText="Switch to New Version"
          onClick={handleSwitchToNewVersion}
        />
      </div>

      {children}
    </DashboardLayout>
  );
}

export default connect(state => state, null)(Layout);
